export enum Manufacturer {
  APPLE = 'APPLE',
  OTHER = 'OTHER',
}
